import { useMemo } from "react";

import { colorsSets } from "@similarweb/styles";

import { useActivationSet } from "../../../hooks/useActivationSet";

type Domain = string;
type Color = string;

type DomainColorMap = Record<Domain, Color>;

const MAX_STATIC_COLOR_DOMAINS = 10;
const colors = colorsSets.c.toArray();

export const useDomainColorMap = (): DomainColorMap | null => {
    const { activationSet } = useActivationSet();
    const allDomains = activationSet?.allDomains;

    return useMemo(() => {
        if (!allDomains || allDomains.length > MAX_STATIC_COLOR_DOMAINS) {
            return null;
        }

        return allDomains.reduce<DomainColorMap>((map, domain, index) => {
            map[domain] = colors[index % colors.length];
            return map;
        }, {});
    }, [allDomains]);
};
